import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PurposeType } from '@types'

interface PurposeTypesState {
  purposeTypes: PurposeType[]
  isLoading: boolean
  error: null
}

const initialState: PurposeTypesState = {
  purposeTypes: [],
  isLoading: false,
  error: null
}

const slice = createSlice({
  name: 'purpose-types',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false
      state.error = action.payload
    },

    // GET Purpose Types
    getAllPurposeTypesSuccess(state, action: PayloadAction<PurposeType[]>) {
      state.isLoading = false
      state.purposeTypes = action.payload
      state.error = null
    },
    clearAllPurposeTypes(state) {
      state.isLoading = false
      state.purposeTypes = []
      state.error = null
    }
  }
})

// Reducer
export const { getAllPurposeTypesSuccess, hasError, startLoading, clearAllPurposeTypes } = slice.actions
export default slice.reducer
